import type { CSSProperties, ReactNode } from 'react';
import { Icon, type IconName } from '@/components/foundations';
import { PAYMENT_STATUS, type PaymentStatus } from './status';

export type BadgeTone = 'ok' | 'warn' | 'err' | 'gold' | 'neutral';

export type BadgeProps = {
  /** Sem `tone` = selo "Ativo" das integrações/conexões. */
  tone?: BadgeTone;
  /** Bolinha antes do texto (`dot`). */
  dot?: boolean;
  icon?: IconName;
  style?: CSSProperties;
  children: ReactNode;
};

/** Selo de status (`.badge`). */
export function Badge({ tone, dot, icon, style, children }: BadgeProps) {
  return (
    <span className={['badge', tone, dot ? 'dot' : ''].filter(Boolean).join(' ')} style={style}>
      {icon && <Icon name={icon} />}
      {children}
    </span>
  );
}

/** Status de pagamento (Aprovado / Pendente / Recusado), rótulo e tom de `PAYMENT_STATUS`. */
export function StatusBadge({ status, dot }: { status: PaymentStatus; dot?: boolean }) {
  return <Badge tone={status} dot={dot}>{PAYMENT_STATUS[status].label}</Badge>;
}

export type InstallmentBadgeProps = { n: number; of: number } | { value: string };

/** Parcela "3/10" (`badge gold`). */
export function InstallmentBadge(props: InstallmentBadgeProps) {
  return <Badge tone="gold">{'value' in props ? props.value : `${props.n}/${props.of}`}</Badge>;
}
